export const EVENTS = {
    LOGIN_VIA_PLUGIN: 'LOGIN_VIA_PLUGIN'
}